export default function formatWorkspaceFromUserRoles(userRoles) {
  return userRoles?.reduce((acc, currentValue) => {
    if (currentValue.workspace) {
      acc.push({ role: currentValue.role.name, ...currentValue.workspace });
    }

    return acc;
  }, []);
}
